import { render, staticRenderFns } from "./AppImageForm.vue?vue&type=template&id=06e2d940&"
import script from "./AppImageForm.vue?vue&type=script&lang=js&"
export * from "./AppImageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports